"use strict";

var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _text = require("./text.tokens");
var _tokens = _interopRequireDefault(require("../../shared/tokens/tokens"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _useElementIsTruncated = require("../../hooks/useElementIsTruncated");
var _Tooltip = _interopRequireDefault(require("../../components/feedback/tooltip/Tooltip"));
var _enums = require("../../shared/tokens/enums");
var _globalTokenUtil = require("../../shared/global-token-util");
var _jsxRuntime = require("react/jsx-runtime");
// FIXME remove usages of old color values from web-front and then cleanup this type by removing | keyof typeof textTokens.color.body and remove textTokens.color.body from the TextColor object
var TextColor = _objectSpread({}, _enums.SysColorTextContent, _enums.SysColorTextSemantic, _enums.SysColorTextDisabled, (0, _globalTokenUtil.getTokenKeyEnum)(_text.tokens.color.body));

// FIXME find a better way to type these token sizes, in webfront they are either strings or numbers

var StyledText = _styledComponents.default.div.withConfig({
  displayName: "Text__StyledText",
  componentId: "sc-1sos95r-0"
})(["display:inline-block;", " color:", ";text-decoration:", ";cursor:inherit;white-space:", ";", ""], function (_ref) {
  var size = _ref.size,
    theme = _ref.theme;
  return theme.sys.font.body[size];
}, function (_ref2) {
  var color = _ref2.color;
  return _text.tokens.color.body[color];
}, function (_ref3) {
  var underline = _ref3.underline;
  return underline ? 'underline' : 'none';
}, function (_ref4) {
  var noWrap = _ref4.noWrap;
  return noWrap ? 'nowrap' : 'pre-wrap';
}, function (_ref5) {
  var ellipsis = _ref5.ellipsis;
  return ellipsis ? (0, _styledComponents.css)(["display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;overflow:hidden;word-break:break-all;"]) : (0, _styledComponents.css)([""]);
});
var Text = function Text(_ref6) {
  var children = _ref6.children,
    _ref6$size = _ref6.size,
    size = _ref6$size === void 0 ? '1' : _ref6$size,
    _ref6$color = _ref6.color,
    color = _ref6$color === void 0 ? TextColor.main : _ref6$color,
    noWrap = _ref6.noWrap,
    underline = _ref6.underline,
    ellipsis = _ref6.ellipsis,
    tooltipOnEllipsis = _ref6.tooltipOnEllipsis,
    dataCy = _ref6['data-cy'];
  var _ref7 = (0, _useElementIsTruncated.useElementIsTruncated)(),
    _ref8 = _slicedToArray(_ref7, 2),
    ref = _ref8[0],
    isTruncated = _ref8[1];
  var ellipsisTooltip = ellipsis && tooltipOnEllipsis;
  var styledText = /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledText, {
    ref: ellipsisTooltip ? ref : undefined,
    size: size,
    color: color,
    noWrap: noWrap,
    underline: underline,
    ellipsis: ellipsis,
    "data-cy": dataCy,
    children: children
  });
  return ellipsisTooltip && isTruncated ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.default, {
    interactable: false,
    content: children,
    children: styledText
  }) : styledText;
};
var _default = exports.default = Text;
Text.Size = _tokens.default.sky.sys.font.body;
Text.Color = TextColor;
Text.color = TextColor;